import React from 'react';

import SearchOrders from 'components/Returns/SearchOrders';
import { ContentContainer } from 'components/ui/ContentContainer';

const CreateReturn: React.FC = () => {
    return (
        <ContentContainer align="center" className="home-create-return" $grow={1} column>
            <SearchOrders className="mb-0" />
        </ContentContainer>
    );
};

export default CreateReturn;
